//引入mockjs模块
import Mock from 'mockjs'

//引入json数据文件
//json文件会默认向外暴漏可直接引入
import bannerList from './home/bannerList'
import productShow from './home/productShow.json'
import newsList from './news/newsList.json'
import trends from './news/trends'
import recommendedNews from './news/recommendedNews.json'
import productList1 from './product/productList1'
import productList2 from './product/productList2'
import productList3 from './product/productList3'
import productList4 from './product/productList4'


//mock数据：第一个参数：请求的地址，第二个参数：请求的数据
Mock.mock("/mock/bannerList", { code: 200, data: bannerList }) //模拟首页轮播图的数据
Mock.mock("/mock/productShow", { code: 200, data: productShow }) //模拟首页产品展示的数据

Mock.mock("/mock/newList", { code: 200, data: newsList }) //模拟新闻页的数据
Mock.mock("/mock/trends", { code: 200, data: trends }) //模拟行业动态的数据
Mock.mock("/mock/recommendedNews", { code: 200, data: recommendedNews }) //模拟新闻推荐的数据

Mock.mock("/mock/productList1", { code: 200, data: productList1 }) //模拟产品页第一分页内容
Mock.mock("/mock/productList2", { code: 200, data: productList2 }) //模拟产品页第二分页内容
Mock.mock("/mock/productList3", { code: 200, data: productList3 }) //模拟产品页第三分页内容
Mock.mock("/mock/productList4", { code: 200, data: productList4 }) //模拟产品页第四分页内容

